import clsx from "clsx";
import { Icon_HangUpPhoneCall, Icon_SplitCall } from "../BP2Components/Icons/icons";
import { useIntl } from "react-intl";

export const ParticipantList = ({ users }) => {
   const intl = useIntl();
   return (
      <ul className="call-manager__participant-list">
         {users.map((user, index) => (
            <li key={`${user.name}-${index}`} className="call-manager__participant-list-item">
               <div className="call-manager__participant-list-info">
                  <p>{user.name || intl.formatMessage({ id: "callManager.noUserName" })}</p>
                  <span>
                     {user.number || intl.formatMessage({ id: "callManager.noPhoneNumber" })}
                  </span>
               </div>
               <div className="call-manager__participant-list-buttons">
                  <button
                     className={clsx(
                        "call-manager__action-button call-manager__action-button--participant",
                     )}
                  >
                     <div>
                        <Icon_SplitCall />
                     </div>
                  </button>
                  <button
                     className={clsx(
                        "call-manager__action-button call-manager__action-button--end-call call-manager__action-button--participant",
                     )}
                  >
                     <div>
                        <Icon_HangUpPhoneCall />
                     </div>
                  </button>
               </div>
            </li>
         ))}
      </ul>
   );
};
